import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  roles: [],
  selectedRole: null,
};

const roleSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    // Get Roles
    getRolesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getRolesSuccess: (state, action) => {
      state.loading = false;
      state.roles = action.payload;
      state.error = null;
    },
    getRolesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Role
    createRoleStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createRoleSuccess: (state, action) => {
      state.loading = false;
      state.roles.push(action.payload);
      state.error = null;
    },
    createRoleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Role
    updateRoleStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateRoleSuccess: (state, action) => {
      state.loading = false;
      const index = state.roles.findIndex(
        (role) => role.id === action.payload.id,
      );
      if (index !== -1) {
        state.roles[index] = action.payload;
      }
      state.error = null;
    },
    updateRoleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete Role
    deleteRoleStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteRoleSuccess: (state, action) => {
      state.loading = false;
      state.roles = state.roles.filter((role) => role.id !== action.payload);
      state.error = null;
    },
    deleteRoleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Role
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getRolesStart,
  getRolesSuccess,
  getRolesFailure,
  createRoleStart,
  createRoleSuccess,
  createRoleFailure,
  updateRoleStart,
  updateRoleSuccess,
  updateRoleFailure,
  deleteRoleStart,
  deleteRoleSuccess,
  deleteRoleFailure,
  setSelectedRole,
  clearError,
} = roleSlice.actions;

export default roleSlice.reducer;
